
import AddIcon from '@material-ui/icons/Add';

export default function AddButton(props){
  return <AddIcon {...props}/>;
}
